export default function HowItWorks() {
  const steps = [
    {
      number: '1',
      title: 'Strategy Call',
      description: 'We analyze your business, target market, and competition to create a custom marketing plan designed specifically for your detailing business.',
      timeline: 'Day 1'
    },
    {
      number: '2',
      title: 'Campaign Launch',
      description: 'We build your landing pages, set up your ads, and launch your campaigns across Facebook and Google to start generating leads immediately.',
      timeline: 'Day 2'
    },
    {
      number: '3',
      title: 'Lead Generation',
      description: 'Qualified leads start flowing in. Our automated system follows up with each lead and books appointments directly into your calendar.',
      timeline: 'Day 3'
    },
    {
      number: '4',
      title: 'Scale & Optimize',
      description: 'We continuously optimize your campaigns, scale what works, and ensure you hit 30+ clients within 60 days or you get paid $1,000.',
      timeline: 'Day 4'
    }
  ];

  return (
    <section id="how-it-works" className="bg-[#F5F1E8] py-24 relative">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-20 relative z-20">
          <div className="text-[#0066FF] text-sm font-bold tracking-widest uppercase mb-4">
            THE PROCESS
          </div>
          <h2 className="text-5xl lg:text-6xl font-bold text-[#0A1628]">
            From Zero to Fully Booked in 60 Days
          </h2>
        </div>

        <div className="relative z-10">
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-1 bg-[#0066FF] transform -translate-y-1/2"></div>

          <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 lg:gap-4">
            {steps.map((step, index) => (
              <div
                key={index}
                className={`relative ${index % 2 === 0 ? 'lg:-mt-32' : 'lg:mt-32'}`}
              >
                <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all">
                  <div className="w-28 h-28 bg-[#0066FF] rounded-full flex items-center justify-center mx-auto mb-6 relative z-10">
                    <span className="text-6xl font-bold text-white font-serif">{step.number}</span>
                  </div>
                  <div className="text-xs text-gray-500 font-semibold uppercase tracking-wider mb-3 text-center">
                    {step.timeline}
                  </div>
                  <h3 className="text-2xl font-bold text-[#0A1628] mb-4 text-center">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed text-center">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-16 relative z-20">
          <button
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-[#0A1628] text-white px-10 py-4 rounded-lg text-lg font-bold hover:bg-[#0A1628]/90 transition-all whitespace-nowrap cursor-pointer"
          >
            Start Your 60-Day Journey
          </button>
        </div>
      </div>
    </section>
  );
}
